import { RatingGaugeWebElementBase } from './RatingGaugeWebElementBase';

/**
 * The component WebElement for [oj-c-rating-gauge](../../jsdocs/oj-c.RatingGauge.html).
 * Do not instantiate this class directly, instead, use
 * [findRatingGauge](../functions/findRatingGauge.html).
 */
export class RatingGaugeWebElement extends RatingGaugeWebElementBase {
  // Put overrides here
}
